/**
 * Vista: Lista de Checklist de Entrega
 * Formato: AMX-VTA-FR-11_R7
 */

import ventasService from '../services/ventas.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';
import modal from '../utils/modal.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">Checklist de Entrega</h2>
          ${permisos.canCreate('checklist_entrega') ? `<button class="btn btn-primary" onclick="router.navigate('/ventas/checklist-entrega/nuevo')">
            + Nuevo Checklist
          </button>` : ''}
        </div>

        <!-- Filtros -->
        <div class="filters" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input type="text" id="busqueda" class="form-input" placeholder="Num. Serie, Distribuidor..." />
          </div>
          <div class="form-group">
            <label class="form-label">Desde</label>
            <input type="date" id="fechaDesde" class="form-input" />
          </div>
          <div class="form-group">
            <label class="form-label">Hasta</label>
            <input type="date" id="fechaHasta" class="form-input" />
          </div>
          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" onclick="window.checklistDocListView.limpiarFiltros()" style="width: 100%;">
              Limpiar Filtros
            </button>
          </div>
        </div>

        <!-- Tabla -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Num. Serie</th>
                <th class="tbl-hide-mobile">Fecha</th>
                <th class="tbl-hide-mobile">Modelo</th>
                <th class="tbl-hide-mobile">Distribuidor</th>
                <th class="tbl-hide-mobile">Tipo Venta</th>
                <th class="tbl-hide-mobile">Estado</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="checklistTableBody">
              <tr>
                <td colspan="8" style="text-align: center; padding: 2rem;">
                  Cargando checklists...
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div id="pagination" class="pagination" style="margin-top: 1rem;"></div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('checklist_entrega')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    window.checklistDocListView = this;

    this.currentPage = 1;
    this.limit = 10;
    this.filters = {};

    document.getElementById('busqueda').addEventListener('input', (e) => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filters.search = e.target.value;
        this.currentPage = 1;
        this.cargarChecklists();
      }, 500);
    });

    document.getElementById('fechaDesde').addEventListener('change', (e) => {
      this.filters.fecha_desde = e.target.value;
      this.currentPage = 1;
      this.cargarChecklists();
    });

    document.getElementById('fechaHasta').addEventListener('change', (e) => {
      this.filters.fecha_hasta = e.target.value;
      this.currentPage = 1;
      this.cargarChecklists();
    });

    await this.cargarChecklists();
  },

  async cargarChecklists() {
    try {
      const params = {
        page: this.currentPage,
        limit: this.limit,
        ...this.filters
      };

      const response = await ventasService.listarChecklistDocumentos(params);
      const data = response.data || response;
      const checklists = data.checklists || [];
      const pagination = data.pagination || { page: 1, totalPages: 1, total: 0 };

      this.renderChecklists(Array.isArray(checklists) ? checklists : []);
      this.renderPaginacion(pagination);
    } catch (error) {
      toast.error('Error al cargar checklists');
      this.renderChecklists([]);
    }
  },

  renderChecklists(checklists) {
    const tbody = document.getElementById('checklistTableBody');

    if (!checklists || checklists.length === 0) {
      tbody.innerHTML = `
        <tr>
          <td colspan="8" style="text-align: center; padding: 2rem;">
            No se encontraron checklists
          </td>
        </tr>
      `;
      return;
    }

    const fechaFmt = (f) => f ? new Date(f).toLocaleDateString('es-MX') : '-';
    const tipoVenta = (t) => t === 'credito' ? 'Crédito' : t === 'contado' ? 'Contado' : '-';
    const estadoBadge = (c) => c.completada
      ? '<span class="badge badge-success">Completada</span>'
      : '<span class="badge badge-warning">Pendiente</span>';

    const acciones = (c) => c.completada
      ? `${permisos.canView('checklist_entrega') ? `<button class="btn btn-sm btn-primary" onclick="window.checklistDocListView.verDetalle(${c.id})">Ver</button>` : ''}`
      : `${permisos.canEdit('checklist_entrega') ? `<button class="btn btn-sm btn-primary" onclick="window.checklistDocListView.verDetalle(${c.id})">Editar</button>` : ''}
         ${permisos.canDelete('checklist_entrega') ? `<button class="btn btn-sm btn-danger" onclick="window.checklistDocListView.eliminarChecklist(${c.id})">Eliminar</button>` : ''}`;

    tbody.innerHTML = checklists.map(c => `
      <tr>
        <td>
          <button class="tbl-expand-btn" onclick="window.checklistDocListView.toggleRow(${c.id})">&#9654;</button>
        </td>
        <td><strong>${c.num_serie}</strong></td>
        <td class="tbl-hide-mobile">${fechaFmt(c.fecha)}</td>
        <td class="tbl-hide-mobile">${c.modelo || '-'}</td>
        <td class="tbl-hide-mobile">${c.distribuidor || '-'}</td>
        <td class="tbl-hide-mobile">${tipoVenta(c.tipo_venta)}</td>
        <td class="tbl-hide-mobile">${estadoBadge(c)}</td>
        <td class="tbl-hide-mobile">
          <div style="display: flex; gap: 0.5rem;">${acciones(c)}</div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-chk-${c.id}">
        <td colspan="8" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Fecha</dt><dd>${fechaFmt(c.fecha)}</dd>
            <dt>Modelo</dt><dd>${c.modelo || '-'}</dd>
            <dt>Distribuidor</dt><dd>${c.distribuidor || '-'}</dd>
            <dt>Tipo Venta</dt><dd>${tipoVenta(c.tipo_venta)}</dd>
            <dt>Estado</dt><dd>${estadoBadge(c)}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">
            ${acciones(c)}
          </div>
        </td>
      </tr>
    `).join('');
  },

  renderPaginacion(pagination) {
    const container = document.getElementById('pagination');
    const { page, totalPages } = pagination;

    if (totalPages <= 1) {
      container.innerHTML = '';
      return;
    }

    let html = '<div style="display: flex; justify-content: center; gap: 0.5rem;">';
    html += `<button class="btn btn-sm btn-secondary" ${page <= 1 ? 'disabled' : ''} onclick="window.checklistDocListView.irAPagina(${page - 1})">← Anterior</button>`;
    html += `<span style="padding: 0.5rem; font-size: 0.9rem;">Página ${page} de ${totalPages}</span>`;
    html += `<button class="btn btn-sm btn-secondary" ${page >= totalPages ? 'disabled' : ''} onclick="window.checklistDocListView.irAPagina(${page + 1})">Siguiente →</button>`;
    html += '</div>';
    container.innerHTML = html;
  },

  irAPagina(page) {
    this.currentPage = page;
    this.cargarChecklists();
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-chk-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      if (btn) btn.classList.toggle('expanded');
    }
  },

  verDetalle(id) {
    router.navigate(`/ventas/checklist-entrega/${id}`);
  },

  async eliminarChecklist(id) {
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar este checklist de entrega? Esta acción no se puede deshacer.`,
      async () => {
        try {
          await ventasService.eliminarChecklistDocumentos(id);
          toast.success('Checklist eliminado');
          await this.cargarChecklists();
        } catch (error) {
          toast.error(error.message || 'Error al eliminar');
        }
      }
    );
  },

  limpiarFiltros() {
    document.getElementById('busqueda').value = '';
    document.getElementById('fechaDesde').value = '';
    document.getElementById('fechaHasta').value = '';
    this.filters = {};
    this.currentPage = 1;
    this.cargarChecklists();
  }
};
